import { memo, useMemo } from "react";
import { Box } from "@chakra-ui/react";

import { Dropdown, DropdownOption } from "../../../components/Dropdown";
import { TemplateRow } from "features/profile-templates/types";

const PLACEHOLDER = "Choose a template";

interface ITemplateDropdownProps {
  templates: TemplateRow[] | undefined;
  value: number | null;
  onChange: (id: number) => void;
  isLoading: boolean;
}

export const TemplateDropdown = memo(function TemplateDropdown({
  templates,
  value,
  onChange,
  isLoading,
}: ITemplateDropdownProps) {
  const options = useMemo<DropdownOption<number>[]>(
    () => templates?.map(t => ({ label: t.name, value: t.id })) ?? [],
    [templates],
  );

  return (
    <Box pt={4} pb={2}>
      <Dropdown<number>
        options={options}
        value={value}
        onChange={onChange}
        placeholder={PLACEHOLDER}
        isLoading={isLoading}
        ariaLabel={PLACEHOLDER}
      />
    </Box>
  );
});
